// @flow
import { TABS } from 'Client/cms/toolkit/constants';
import { TabsLine } from 'Components/lines/tabs-line/TabsLine';

export const tabsDescriptor = {
  name: TABS,
  component: TabsLine,
};
